<template>
    <el-dialog custom-class="risk_tip_dialog" :model-value="show" width="700px" destroy-on-close :lock-scroll="false" @close="handleClose">
        <div class="dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <h1>高风险舆情处置提醒</h1>
            <p>
                您当前有<span @click="openHighRiskSearch">{{ info.count }}条</span>待处置高风险舆情，请查看识别到的风险场景的<span @click="openSuggest">应急处置建议</span>
            </p>
            <div class="check_box">
                <el-checkbox v-model="checked" label="我已知悉，不再提醒。" />
            </div>
            <div class="btn_box">
                <el-button type="primary" @click="submit">确定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import { Close } from "@element-plus/icons-vue";
import { apiCommonConfirm } from "@/request/api";
import { useRouter } from "vue-router";
import useTip from "@/store/modules/useTip";
import { storeToRefs } from "pinia";

const router = useRouter();
const props = defineProps({
    show: { type: Boolean, default: false },
});
const emits = defineEmits(["close"]);
const tipStore = useTip();
const { info } = storeToRefs(tipStore);
const checked = ref(false);

function submit() {
    if (checked.value) {
        apiCommonConfirm();
    }
    handleClose();
}

// 打开高风险搜索页
function openHighRiskSearch() {
    const query = { risk: "high" };
    if (info.value.start && info.value.end) {
        query.pullStartTime = info.value.start;
        query.pullEndTime = info.value.end;
    }
    const { href } = router.resolve({
        path: "/search",
        query,
    });
    window.open(href, "_blank");
}

// 打开应急处理建议
function openSuggest() {
    const { href } = router.resolve({
        path: "/suggest",
    });
    window.open(href, "_blank");
}

// 关闭
function handleClose() {
    checked.value = false;
    emits("close");
}
</script>

<style lang="scss">
.risk_tip_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .dialog_content {
        padding: 36px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        h1 {
            font-size: 24px;
            font-weight: 400;
            color: #000;
        }
        p {
            padding-top: 50px;
            color: #333;
            font-size: 14px;
            span {
                color: #2a82e4;
                text-decoration: underline;
                cursor: pointer;
            }
        }
        .check_box {
            padding-top: 80px;
        }
        .btn_box {
            padding: 0 90px;
            padding-top: 16px;
            .el-button {
                width: 100%;
            }
        }
    }
}
</style>
